const Styles = theme => ({        
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
});
export default Styles;